<template lang="pug">
.cp-rights-swipper
  .w
    .swipper-title 全独立知识产权
    .wrap
      .arrow.arrowL(@click="changeIndex(-1)")
      ul.container
        li.img-wrap(v-for="(v, index) in list", :class="`transform${v.currentPosition}`" @click="changePosition(v.currentPosition)")
          .img(:class="`img${index + 1}`")
          .img.reflect(:class="`img${index + 1}`")
      .arrow.arrowR(@click="changeIndex(1)")
</template>
<script>
export default {
  components: {},
  props: {},
  data () {
    return {
      list: [
        { img: require('@/assets/zhanli1.jpg'), currentPosition: 0 },
        { img: require('@/assets/zhanli2.jpg'), currentPosition: 1 },
        { img: require('@/assets/zhanli3.jpg'), currentPosition: 2 },
        { img: require('@/assets/zhanli4.jpg'), currentPosition: 3 },
        { img: require('@/assets/zhanli5.jpg'), currentPosition: 4 },
        { img: require('@/assets/zhanli6.jpg'), currentPosition: 5 },
        { img: require('@/assets/zhanli7.jpg'), currentPosition: 6 },
        { img: require('@/assets/zhanli8.jpg'), currentPosition: 7 },
        { img: require('@/assets/zhanli9.jpg'), currentPosition: 8 },
        { img: require('@/assets/zhanli10.jpg'), currentPosition: 9 },
        { img: require('@/assets/zhanli11.jpg'), currentPosition: 10 },
        { img: require('@/assets/zhanli12.jpg'), currentPosition: 11 },
      ]
    }
  },
  computed: {},
  methods: {
    changeIndex (diff) {
      this.list.forEach(v => {
        v.currentPosition += diff
        if (v.currentPosition < 0) v.currentPosition += 12
        v.currentPosition %= 12
      })
    },
    changePosition (pos) {
      if (pos < 4) {
        // for (let i = 0; i < pos; i++) {
        //   this.changeIndex(-1)
        // }
        this.changeIndex(-pos)
      } else if (pos > 8) {
        // for (let i = 0; i < 12 - pos; i++) {
        //   this.changeIndex(1)
        // }
        this.changeIndex(12 - pos)
      }
    }
  }
}
</script>
<style lang="stylus">
.cp-rights-swipper
  margin-bottom 200px
  .swipper-title
    font-size 24px
    text-align center
    margin-bottom 66px
  .wrap
    padding 0px 65px
    height 180px
    display flex
    justify-content space-between
    align-items center
    .arrow
      width 35px
      height 60px
      // margin-top 20px
      cursor pointer
      transition all .3s
      &:hover
        transform scale(1.1)
      &::before
        content ''
        display block
        width 7px
        height 34px
        background #FFF
        box-shadow 0px 0px 10px #FFFFFF
      &::after
        content ''
        display block
        width 7px
        height 34px
        background #FFF
        box-shadow 0px 0px 10px #FFFFFF
    .arrowL
      float left
      &::before
        transform translate(13px, 3px) rotate(45deg)
      &::after
        transform translate(13px, -11px) rotate(-45deg)
    .arrowR
      float right
      &::before
        transform translate(13px, 3px) rotate(-45deg)
      &::after
        transform translate(13px, -11px) rotate(45deg)
    .container
      width 74px
      height 104px
      margin 0 auto
      transform-style preserve-3d
      perspective: 1000px
      perspective-origin center
      .img-wrap
        position absolute
        left 0px
        top 0px
        transition all .5s
        .img
          width 74px
          height 104px
          background-position center
          background-size 100% 100%
          background-repeat no-repeat
        .img1
          background-image url('../../../assets/zhanli1.jpg')
        .img2
          background-image url('../../../assets/zhanli2.jpg')
        .img3
          background-image url('../../../assets/zhanli3.jpg')
        .img4
          background-image url('../../../assets/zhanli4.jpg')
        .img5
          background-image url('../../../assets/zhanli5.jpg')
        .img6
          background-image url('../../../assets/zhanli6.jpg')
        .img7
          background-image url('../../../assets/zhanli7.jpg')
        .img8
          background-image url('../../../assets/zhanli8.jpg')
        .img9
          background-image url('../../../assets/zhanli9.jpg')
        .img10
          background-image url('../../../assets/zhanli10.jpg')
        .img11
          background-image url('../../../assets/zhanli11.jpg')
        .img12
          background-image url('../../../assets/zhanli12.jpg')

        .reflect
          transform rotateY(180deg)
          &.img1
            background-image url('../../../assets/zhanli-drop1.png')
          &.img2,
          &.img5,
          &.img7,
          &.img8,
          &.img9,
          &.img11
            background-image url('../../../assets/zhanli-drop2.png')
          &.img3,
          &.img4,
          &.img6,
          &.img10,
          &.img12
            background-image url('../../../assets/zhanli-drop3.png')
      .transform0
        transform translate3d(0, 7px, 300px)
        z-index 1
      .transform1
        transform translate3d(125px, 5px, 200px)
        z-index 1
      .transform2
        transform translate3d(250px, 3px, 100px)
        z-index 1
      .transform3
        transform translate3d(380px, 0, 0)
        filter blur(1px)
        opacity .9
      .transform4
        transform translate3d(280px, -30px, -100px) scale(1.1)
        filter blur(3px)
        opacity .7
        .reflect
          opacity 0
          // display none
      .transform5
        transform translate3d(150px, -40px, -200px) scale(1.2)
        filter blur(5px)
        opacity .5
        .reflect
          opacity 0
          // display none
      .transform6
        transform translate3d(0, -55px, -300px) scale(1.3)
        filter blur(10px)
        opacity .3
        .reflect
          opacity 0
          // display none
      .transform7
        transform translate3d(-150px, -40px, -200px) scale(1.2)
        filter blur(5px)
        opacity .5
        .reflect
          opacity 0
          // display none
      .transform8
        transform translate3d(-260px, -30px, -100px) scale(1.1)
        filter blur(3px)
        opacity .7
        .reflect
          opacity 0
          // display none
      .transform9
        transform translate3d(-397px, 0, 0)
        filter blur(1px)
        opacity .9
      .transform10
        transform translate3d(-260px, 3px, 100px)
        z-index 1
      .transform11
        transform translate3d(-130px, 5px, 200px)
        z-index 1
</style>
